/**
 * Appends a suffix to the base key based on the provided type.
 * If the type is 'carehome', no suffix will be added.
 *
 * @param baseKey - The base language key
 * @param type - The user type (e.g., 'clinic', 'carehome')
 * @returns A language key with or without the type suffix
 */
export const getLanguageKeyByType = (
  baseKey: string,
  type?: string
): string => {
  if (!type || type === 'carehome' || type === 'Carehome') {
    // Return the base key if type is undefined or 'carehome'
    return baseKey;
  }

  // Convert type to PascalCase (e.g., 'clinic' -> 'Clinic')
  const suffix = type.charAt(0).toUpperCase() + type.slice(1);

  // Append the suffix to the base key
  return `${baseKey}${suffix}`;
};
